//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SfHeader from "~/themes/fiskarsMoominDefault/components/components/organisms/SfHeader/SfHeader.vue";
import SfButton from "~/themes/fiskarsMoominDefault/components/components/atoms/SfButton/SfButton.vue";
import SfBadge from "~/themes/fiskarsMoominDefault/components/components/atoms/SfBadge/SfBadge.vue";
import SfOverlay from "~/themes/fiskarsMoominDefault/components/components/atoms/SfOverlay/SfOverlay.vue";
import SfIcon from "~/themes/fiskarsMoominDefault/components/components/atoms/SfIcon/SfIcon.vue";
import MoominHeaderSearch from "~/themes/fiskarsMoominDefault/components/components/organisms/MoominHeaderSearch/MoominHeaderSearch.vue";
import { useUiState, useUserAccount } from "~/composables";
import {
  computed,
  ref,
  useRouter,
  defineComponent,
  useRoute,
  onMounted,
  useContext,
  watch,
  onBeforeUnmount,
} from "@nuxtjs/composition-api";
import { useVSFContext } from "@vue-storefront/core";
import analyticsEvents from "~/helpers/analytics/analyticsEvents";
import useCoveoHeadlessSearch from "~/composables/useCoveoHeadless/search";
import CategoryBreadcrumbs from "~/components/Category/CategoryBreadcrumbs.vue";
import { getBreadcrumbs } from "~/common";
import LocaleSelectorButton from "~/components/LocaleSelectorButton.vue";
import initializeDatadogRum from "~/helpers/logging/startDDRUM";
import initializeDatadogLogs from "~/helpers/logging/browser-logs";
import {validateInputField } from "~/helpers/validation-utils";

export default defineComponent({
  name: "AppHeader",
  components: {
    LocaleSelectorButton,
    SfHeader,
    SfButton,
    SfBadge,
    SfOverlay,
    MoominHeaderSearch,
    CategoryBreadcrumbs,
    SfIcon,
  },
  props: {
    placeholder: {
      type: String,
      default: "Search for items",
    },
    accountIcon: {
      type: [Object, String],
    },
    cartIcon: {
      type: [Object, String],
    },
    suggestionsPlaceholder: {
      type: String,
    },
    topSearchesPlaceholder: {
      type: String,
    },
    noSuggestionsPlaceholder: {
      type: String,
    },
    benefitBarData: {
      type: Object,
    },
    cartTotalItems: {
      type: Number,
      default: 0
    }
  },
  setup() {
    const {
      toggleCartSidebar,
      isMobileMenuOpen,
      toggleMobileMenu,
      openSearchModal,
      closeSearchModal,
      isSearchOpen,
    } = useUiState();
    const { i18n, $config } = useContext();

    const route = useRoute();
    const { searchBox } = useCoveoHeadlessSearch();
    const searchBoxRef = ref(searchBox?.state?.suggestions);
    let unsubscribe;

    onMounted(async () => {
      checkAndUpdateCookie($config);

      if(searchBox) {
        unsubscribe = searchBox.subscribe(() => {
          searchBoxRef.value = searchBox?.state?.suggestions;
        });
        // start the RUM
        searchBox.updateText("");
      }
    });

    onBeforeUnmount(() => {
      if (unsubscribe) {
        unsubscribe();
      }
    });

    const { localePath } = useVSFContext();
    const { isAuthenticated } = useUserAccount('user-account-info');

    const router = useRouter();
    const currentRoute = computed(() =>
      route?.value?.params?.pathMatch?.split("/")
    );

    const categoryBreadcrumbs = computed(() => {
      return getBreadcrumbs(currentRoute.value, localePath);
    });

    const term = ref("");
    const searchBarRef = ref(null);

    const crossIconConfig = {
      icon: "close",
      size: "20px",
      color: "var(--c-text)",
    };
    const crossIcon = computed(() => (term.value ? crossIconConfig : {}));

    const handleAccountClick = async () => {
      if (!isAuthenticated) router.push(localePath(i18n.t("PAGES.LOGIN")));
      else router.push(localePath(i18n.t("PAGES.PERSONAL_DETAILS")));
    };

    const updateTerm = (searchTerm) => {
      searchBox.updateText(searchTerm);
      term.value = searchTerm;
    };

    const handleSearch = (searchTerm, searchType) => {
      term.value = searchTerm;
      searchBox.updateText(term.value);
      if (searchType === "click") {
        searchBox.selectSuggestion(searchTerm);
        analyticsEvents.productsSearched(
          searchBox?.state?.suggestions.length,
          searchTerm
        );
      } else {
        searchBox.submit();
        searchBox.clear();
      }
      closeSearchModal();
      router.push(
        localePath(`${i18n.t("PAGES.SEARCH_RESULTS")}?searchTerm=${searchTerm}`)
      );
    };

    const closeSearchOnEscape = () => {
      term.value = "";
      searchBox.updateText("");
      closeSearchModal();
    };
    const resetSearchTerm = watch(isSearchOpen, (newVal) => {
      if(!newVal) term.value = "";
    })


    const showSearchSuggestions = computed(
      () => searchBox?.state?.suggestions && isSearchOpen.value
    );

    const checkIsValid = computed(() => {
      const searchTerm = term?.value?.trim();
      const fieldLabel = i18n.t("Search");
      return searchTerm === ""
        ? { isValid: true, errorMessage: "" }
        : validateInputField(searchTerm, fieldLabel, "search");
    });

    const getCookie = (cname) => {
      var match = document.cookie.match(new RegExp('(^| )' + cname + '=([^;]+)'));
      if (match) return match[2];
    };

    const init_dd_script = (config) => {
      window.DD_RUM.setTrackingConsent('granted');
      window.DD_LOGS.setTrackingConsent('granted');
      // start the RUM
      initializeDatadogRum({
        DdrAppId: config.DdrAppId,
        DdrClientToken: config.DdrClientToken,
        DdrSite: config.DdrSite,
        DdrService: config.DdrService,
        DdrEnv: config.DdrEnv,
        CurrentEnv: config.CURRENT_ENV,
      });

      initializeDatadogLogs({
        DdrClientToken: config.DdrClientToken,
        DdrSite: config.DdrSite,
        DdrService: config.DdrService,
        CurrentEnv: config.CURRENT_ENV,
      });
    }

    const delete_dd_cookie = () => {
      if (getCookie("_dd_s")) {
        document.cookie = "_dd_s=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
      }
    }

    const checkAndUpdateCookie = (config) => {
      var oneTrustConsent = getCookie('OptanonConsent');
      if(oneTrustConsent && decodeURIComponent(oneTrustConsent).indexOf('C0004:1') > -1) {
        init_dd_script(config);
      } else {
        window.DD_RUM.setTrackingConsent('not-granted');
        window.DD_LOGS.setTrackingConsent('not-granted');
        delete_dd_cookie()
        window.listenerEnableTryCounter = 1;
        var oneTrustEnablerInterval = setInterval(() => {
          if (window.listenerEnableTryCounter < 30) {
            if(window.OneTrust) {
              clearInterval(oneTrustEnablerInterval);
              window.OneTrust.OnConsentChanged(() => {
                if (window.OptanonActiveGroups.indexOf("C0004") > -1) {
                  init_dd_script(config);
                } else {
                  window.DD_RUM.setTrackingConsent('not-granted');
                  window.DD_LOGS.setTrackingConsent('not-granted');
                  delete_dd_cookie()
                }
              });
            } else {
              window.listenerEnableTryCounter++
            }
          } else {
            clearInterval(oneTrustEnablerInterval);
          }
        }, 1000);
      }
    }

    return {
      isAuthenticated,
      checkAndUpdateCookie,
      handleAccountClick,
      toggleCartSidebar,
      term,
      isSearchOpen,
      closeSearchOnEscape,
      searchBarRef,
      isMobileMenuOpen,
      toggleMobileMenu,
      openSearchModal,
      closeSearchModal,
      crossIcon,
      searchBoxRef,
      handleSearch,
      searchBox,
      showSearchSuggestions,
      updateTerm,
      categoryBreadcrumbs,
      route,
      checkIsValid
    };
  },
});
